var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgView = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32352_82546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 6.78125C8.72409 6.78125 7.28125 8.22409 7.28125 9.9999C7.28125 11.7757 8.72409 13.2185 10.4999 13.2185C12.2757 13.2185 13.7185 11.7757 13.7185 9.9999C13.7185 8.22409 12.2757 6.78125 10.4999 6.78125ZM10.2557 9.0454C9.85617 9.0454 9.5232 9.37836 9.5232 9.77792H8.45772C8.47992 8.77903 9.27903 7.97992 10.2557 7.97992V9.0454Z",
    fill: "#329EF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2669 9.33411C19.1792 7.98006 15.2947 3.56274 10.5 3.56274C5.70533 3.56274 1.82075 7.98006 0.733074 9.33411C0.422309 9.71147 0.422309 10.2664 0.733074 10.666C1.82075 12.02 5.70533 16.4373 10.5 16.4373C15.2947 16.4373 19.1792 12.02 20.2669 10.666C20.5777 10.2886 20.5777 9.73366 20.2669 9.33411ZM10.5 14.6615C7.92508 14.6615 5.83851 12.575 5.83851 10C5.83851 7.42512 7.92508 5.33855 10.5 5.33855C13.0749 5.33855 15.1615 7.42512 15.1615 10C15.1615 12.575 13.0749 14.6615 10.5 14.6615Z",
    fill: "#329EF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32352_82546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgView);
export default ForwardRef;